import * as React from 'react'

import * as LabelPrimitive from '@radix-ui/react-label'
import { type VariantProps, tv } from 'tailwind-variants'

import { cn } from '@/shared/lib/cn'

// eslint-disable-next-line react-refresh/only-export-components
export const labelVariants = tv({
	base: 'text-sm peer-disabled:cursor-not-allowed',

	variants: {
		variant: {
			default: 'ts-6 flex gap-x-4 items-center cursor-pointer'
		}
	},

	defaultVariants: {
		variant: 'default'
	}
})

export const Label = ({
	ref,
	className,
	...props
}: React.ComponentPropsWithRef<typeof LabelPrimitive.Root> &
	VariantProps<typeof labelVariants>) => (
	<LabelPrimitive.Root
		ref={ref}
		className={cn(labelVariants(), className)}
		{...props}
	/>
)
Label.displayName = LabelPrimitive.Root.displayName
